export default "__VITE_ASSET__5fc57264__"